import axios from 'axios';
import util from '../../../common/util';
import Latlng from './latlng';

const service = {
    // Get map style 
    style: function(styleKey = 'default') {
        return axios.get('/static/map-style/' + styleKey + '.json');
    },
    // Get the latitude and longitude of the center point of the map and zoom
    getMapCenter: function(type) {
        return axios
            .get(
                '/api-site/search/centerPoint?listingType=' +
                (type || 'all-listing')
            )
            .then(res => {
                return new Promise((resolve, reject) => {
                    const data = res.data ? res.data : res;
                    if (data && data.geoPoint) {
                        resolve({
                            lat: Latlng.getLatitude(data.geoPoint),
                            lng: Latlng.getLongitude(data.geoPoint),
                            zoom: data.zoom
                        });
                    } else {
                        reject('Failed to get the center point.');
                    }
                });
            });
    },
    googleGeocode(address, getMapCenter = false) {
        return util.getMapPs().then(maps => {
            return new Promise((resolve, reject) => {
                if (address) {
                    new maps.Geocoder().geocode(
                        { address: address },
                        function(results, status) {
                            if (status === maps.GeocoderStatus.OK) {
                                var latLng = results[0].geometry.location;
                                resolve({
                                    center: {
                                        lat: latLng.lat(),
                                        lng: latLng.lng()
                                    }
                                });
                            } else {
                                if (getMapCenter) {
                                    return service
                                        .getMapCenter('all-listing')
                                        .then(data => {
                                            resolve({
                                                center: {
                                                    lat: data.lat,
                                                    lng: data.lng
                                                },
                                                zoom: data.zoom
                                            });
                                        });
                                } else {
                                    reject(
                                        'Geocode was not successful for the following reason: ' +
                                        status
                                    );
                                }
                            }
                        }
                    );
                } else {
                    reject('Unknown address.');
                }
            });
        });
    },
    // transfer googlemap address query 
    geocode: function(address, getMapCenter = false) {
        return new Promise((resolve, reject) => {
            if (address) {
                axios.get(`/home-j/here-api/geoPoint?query=${address}`).then(res => {
                    if (res.data) {
                        resolve({ center: res.data })
                    } else {
                        this.googleGeocode(
                            address,
                            getMapCenter
                        ).then(resolve, reject);
                    }
                }).catch(_ => {
                    this.googleGeocode(
                        address,
                        getMapCenter
                    ).then(resolve, reject);
                })
            } else {
                reject('Unknown address.');
            }
        });
    },
    // reverse geoparsing 
    latlngToAddress({ lat, lng }) {
        return util.getMapPs().then(maps => {
            return new Promise((resolve, reject) => {
                const latlng = new maps.LatLng(lat, lng);
                const geocoder = new maps.Geocoder();
                geocoder.geocode(
                    { location: latlng, language: 'en' },
                    (results, status) => {
                        if (status === maps.GeocoderStatus.OK) {
                            if (results?.[0]) {
                                const address = results[0].formatted_address;
                                resolve(address);
                            } else {
                                reject('No results found');
                            }
                        } else {
                            reject('Geocoder failed due to: ' + status);
                        }
                    }
                );
            });
        });
    }
};

export default service;
